import { DataModel as CoreDataModel } from '#core/views.ts';

export const DataModel = {
  ...CoreDataModel,
  IpsoSolution: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
  IpsoFieldWellSurveillanceAgent: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
  IpsoNetworkModelAgent: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
} as const;
